import { useState } from 'react';

type RequestFormFields = {
  companyName: string;
  contactName: string;
  phone: string;
  fax: string;
  mobile: string;
  email: string;
  productName: string;
  modelName: string;
  spec: string;
  details: string;
};

const initialForm: RequestFormFields = {
  companyName: '',
  contactName: '',
  phone: '',
  fax: '',
  mobile: '',
  email: '',
  productName: '',
  modelName: '',
  spec: '',
  details: '',
};

const REQUEST_MAIL_TO = 'sejin3356@naver.com';

function buildRequestMailBody(f: RequestFormFields): string {
  return [
    '업체명: ' + f.companyName,
    '담당자: ' + f.contactName,
    '전화: ' + f.phone,
    '팩스: ' + f.fax,
    '휴대폰: ' + f.mobile,
    '이메일: ' + f.email,
    '',
    '제품명: ' + f.productName,
    '모델명: ' + f.modelName,
    '',
    '사양:',
    f.spec,
    '',
    '상세내용:',
    f.details,
  ].join('\n');
}

function OnlineRequestPage() {
  const [form, setForm] = useState<RequestFormFields>(initialForm);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const subject = encodeURIComponent('[온라인 요청서] 문의');
    const body = encodeURIComponent(buildRequestMailBody(form));
    window.location.href = `mailto:${REQUEST_MAIL_TO}?subject=${subject}&body=${body}`;
  };

  return (
    <section className="page">
      <h1 className="page-title">온라인 요청서</h1>
      <p className="page-lead">
        아래 항목을 작성해 주시면 견적·문의 검토에 참고하겠습니다.
      </p>

      <form className="request-form" onSubmit={handleSubmit} noValidate>
        <div className="request-form__grid">
          <div className="request-form__field">
            <label className="request-form__label" htmlFor="companyName">
              업체명
            </label>
            <input
              id="companyName"
              name="companyName"
              type="text"
              className="request-form__input"
              value={form.companyName}
              onChange={handleChange}
              autoComplete="organization"
            />
          </div>

          <div className="request-form__field">
            <label className="request-form__label" htmlFor="contactName">
              담당자
            </label>
            <input
              id="contactName"
              name="contactName"
              type="text"
              className="request-form__input"
              value={form.contactName}
              onChange={handleChange}
              autoComplete="name"
            />
          </div>

          <div className="request-form__field">
            <label className="request-form__label" htmlFor="phone">
              전화
            </label>
            <input
              id="phone"
              name="phone"
              type="tel"
              className="request-form__input"
              value={form.phone}
              onChange={handleChange}
              autoComplete="tel"
            />
          </div>

          <div className="request-form__field">
            <label className="request-form__label" htmlFor="fax">
              팩스
            </label>
            <input
              id="fax"
              name="fax"
              type="text"
              className="request-form__input"
              value={form.fax}
              onChange={handleChange}
            />
          </div>

          <div className="request-form__field">
            <label className="request-form__label" htmlFor="mobile">
              휴대폰
            </label>
            <input
              id="mobile"
              name="mobile"
              type="tel"
              className="request-form__input"
              value={form.mobile}
              onChange={handleChange}
              autoComplete="tel-national"
            />
          </div>

          <div className="request-form__field">
            <label className="request-form__label" htmlFor="email">
              이메일 주소
            </label>
            <input
              id="email"
              name="email"
              type="email"
              className="request-form__input"
              value={form.email}
              onChange={handleChange}
              autoComplete="email"
            />
          </div>

          <div className="request-form__field">
            <label className="request-form__label" htmlFor="productName">
              제품명
            </label>
            <input
              id="productName"
              name="productName"
              type="text"
              className="request-form__input"
              value={form.productName}
              onChange={handleChange}
            />
          </div>

          <div className="request-form__field">
            <label className="request-form__label" htmlFor="modelName">
              모델명
            </label>
            <input
              id="modelName"
              name="modelName"
              type="text"
              className="request-form__input"
              value={form.modelName}
              onChange={handleChange}
            />
          </div>

          <div className="request-form__field request-form__field--full">
            <label className="request-form__label" htmlFor="spec">
              사양
            </label>
            <textarea
              id="spec"
              name="spec"
              className="request-form__textarea"
              rows={4}
              value={form.spec}
              onChange={handleChange}
            />
          </div>

          <div className="request-form__field request-form__field--full">
            <label className="request-form__label" htmlFor="details">
              상세내용
            </label>
            <textarea
              id="details"
              name="details"
              className="request-form__textarea"
              rows={8}
              value={form.details}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="request-form__actions">
          <button type="submit" className="request-form__submit">
            요청 제출
          </button>
        </div>
      </form>
    </section>
  );
}

export default OnlineRequestPage;
